import { useContext, useMemo } from 'react';
import * as R from 'ramda';

// eslint-disable-next-line import/no-cycle
import { AuthContext } from 'authentication/AuthContext';

// This is a helper for the affiliate drop-down in that
// if we need to filter the affiliates based on the permissions
// we can do such with this function. If we add any new affiliate
// permissions then we need to make updates to this file

// TODO: consider just applying this to the affiliateDropdown component
// in common if we use it across the application
const getAffiliatesOptions = (affiliates, roles) => {
  // Allows us to send in a single affiliate role string or an array of affiliate roles
  const allowedRoles = R.flatten([roles]);
  const filteredAffiliates = R.filter(
    R.o(R.any(R.equals(true)), R.props(allowedRoles)),
    affiliates
  );
  return filteredAffiliates.map(
    ({
      dataCompanyId,
      customerIdName,
      customerNameShort,
      inventoryOwner,
      refiner,
      shipper,
      supplier,
      carrier,
      hasActiveSubscription: subscriber,
    }) => ({
      carrier,
      customerIdName,
      dataCompanyId,
      inventoryOwner,
      label: customerNameShort,
      refiner,
      shipper,
      subscriber,
      supplier,
      value: `${customerIdName}-${dataCompanyId}`,
    })
  );
};

const useGetAffiliateOptions = arr => {
  const { affiliates } = useContext(AuthContext);
  const affiliatesOptions = useMemo(() => getAffiliatesOptions(affiliates, arr), [affiliates, arr]);
  return affiliatesOptions;
};

export default useGetAffiliateOptions;
